import api from './api';

const massJoinService = {
  // Start a mass join process
  startMassJoin: async (accountId, links, options = {}) => {
    const response = await api.post('/mass-join', { 
      accountId, 
      links, 
      options 
    });
    return response.data;
  },

  // Get status of a specific process
  getMassJoinStatus: async (processId) => {
    const response = await api.get(`/mass-join/${processId}`);
    return response.data;
  },

  // Get all active processes
  getAllMassJoinProcesses: async () => {
    const response = await api.get('/mass-join');
    return response.data;
  },

  // Pause a process
  pauseMassJoinProcess: async (processId) => {
    const response = await api.put(`/mass-join/${processId}/pause`);
    return response.data;
  },

  // Resume a paused process
  resumeMassJoinProcess: async (processId) => {
    const response = await api.put(`/mass-join/${processId}/resume`);
    return response.data;
  },

  // Cancel a process
  cancelMassJoinProcess: async (processId) => {
    const response = await api.delete(`/mass-join/${processId}`);
    return response.data;
  },

  // Validate and normalize links
  validateLinks: async (links) => {
    const response = await api.post('/mass-join/validate-links', { links });
    return response.data;
  }
};

export default massJoinService;
